import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    document.body.classList.toggle("has-cookie-banner", visible);
    return () => document.body.classList.remove("has-cookie-banner");
  }, [visible]);

  const accept = (type) => {
    localStorage.setItem("cookie_consent", type);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] bg-white border-t border-[#E5E0D8] shadow-lg px-4 py-4 md:py-5" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-4">
        <p className="text-sm text-[#5C5C5C] flex-1">
          Questo sito utilizza cookie tecnici necessari al funzionamento. Nessun cookie di profilazione o tracciamento viene utilizzato.{" "}
          <Link to="/privacy-policy" className="underline text-[#7e823a] hover:text-[#556B2F]">
            Maggiori informazioni
          </Link>
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={() => accept("all")}
            className="px-5 py-2 bg-[#7e823a] text-white text-sm font-medium rounded-full hover:bg-[#6a6e30] transition-colors"
            data-testid="cookie-accept-all"
          >
            Accetta
          </button>
          <button
            onClick={() => accept("necessary")}
            className="px-5 py-2 bg-white text-[#5C5C5C] text-sm font-medium rounded-full border border-[#E5E0D8] hover:bg-[#f5f5f0] transition-colors"
            data-testid="cookie-accept-necessary"
          >
            Solo necessari
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
